export const TRACKING_WAIT_TIMEOUT_MS = 2000;

export const waitForTracking = async (trackingPromises, timeoutMs = TRACKING_WAIT_TIMEOUT_MS) => {
  const promises = trackingPromises.filter(Boolean).map((promise) => Promise.resolve(promise));

  if (!promises.length) return;

  let timeoutId;

  await Promise.race([
    Promise.allSettled(promises),
    new Promise((resolve) => {
      timeoutId = setTimeout(resolve, timeoutMs);
    }),
  ]);

  clearTimeout(timeoutId);
};
